<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g><path fill="#ffc455" d="M4.005 14.367a.52.52 0 0 1-.354-.142.482.482 0 0 1-.151-.36V2a.5.5 0 0 1 .5-.5h8.001a.5.5 0 0 1 .499.5v11.865a.499.499 0 0 1-.82.384l-3.36-2.8-.32-.266-.32.266-3.36 2.8a.483.483 0 0 1-.315.118z"/><path fill="#fab83b" d="m4 13.865 4-3.333 4 3.332V2H4v11.864m.005 1.003A1 1 0 0 1 3 13.864V2a1 1 0 0 1 1-1h8.001A1 1 0 0 1 13 2v11.864a1 1 0 0 1-1.64.769L8 11.833l-3.36 2.8a.983.983 0 0 1-.635.234z"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-bookmark-on',
});
</script>
